import { IcmContact } from "Core/oRPC";

export const getContactDisplayName = (contact?: IcmContact): string => {
    if (!contact) {
        return "";
    }

    const { FirstName, LastName } = contact;
    return `${FirstName || ""} ${LastName || ""}`.trim();
};
